import { render, staticRenderFns } from "./Designone.vue?vue&type=template&id=2a334eda&scoped=true"
import script from "./Designone.vue?vue&type=script&lang=js"
export * from "./Designone.vue?vue&type=script&lang=js"
import style0 from "./Designone.vue?vue&type=style&index=0&id=2a334eda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a334eda",
  null
  
)

export default component.exports